import { render } from "./Caret.vue?vue&type=template&id=64cc9338"
const script = {}
script.render = render

export default script